module.exports = __webpack_public_path__ + "img/icon8.e2489de.jpg";